var CryptoJS = require("crypto-js");

// Read URL query parameters
const urlParams = new URLSearchParams(window.location.search);

// Keys you expect to receive from query params
const keys = [
  "token",
  "name",
  "userGroup",
  "id",
  "fullName",
  "verticalName",
  "dmDistrict",
  "resetToken",
  "verticalId",
  "BeneficiaryId",
  "isHinduKhatikSamaj"
];

// Save each expected param to sessionStorage if it exists
keys.forEach((key) => {
  const value = urlParams.get(key);
  if (value) {
    sessionStorage.setItem(key, value);
  }
});

// Decrypt token
const decryptToken = () => {
  const encryptedToken = sessionStorage.getItem("token");
  if (!encryptedToken) return null;

  const bytes = CryptoJS.AES.decrypt(encryptedToken, "y9L@91nYW%BRfc1g");
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

// Exported session values
export const Token = decryptToken();
export const Name = sessionStorage.getItem("name");
export const UserGroup = sessionStorage.getItem("userGroup");
export const VerticalName = sessionStorage.getItem("verticalName");
export const DmDistrict = sessionStorage.getItem("dmDistrict");
export const ResetToken = sessionStorage.getItem("resetToken");
export const VerticalId = sessionStorage.getItem("verticalId");
export const BeneficiaryId = sessionStorage.getItem("id");
export const FullName = sessionStorage.getItem("fullName");
export const Id = sessionStorage.getItem("BeneficiaryId");
